import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  requestUserTermsPageTitle: 'We need your confirmation',
  requestUserTermsMessage1: 'Dear',
  requestUserTermsMessage2:
    ', in order to activate your account and unlock the full potential of EFEX, we need you to accept our terms and conditions below:',
  requestUserTermsAccept: 'I accept the',
  requestUserTermsLink: 'terms and conditions',
  requestUserLegalPageLink: 'legal page',
  requestUserTermsMessage3:
    'By registering on our platform, you confirm that you have read and understood all our',
  requestUserTermsMessage4: 'in our',
  requestUserTermsMessage5: 'which includes the EFEX Terms of Service.',
  serviceBoxTitle: 'You can receive transfers to your business account in:',
  serviceBoxSubtitle: 'USD, MXN, CNY, EUR, GBP, HKD, CAD, and COP.',
  serviceBoxTitle2: 'With EFEX, you can lock in an exchange rate today',
  serviceBoxSubtitle2: 'and transfer up to 365 days in the future.',
  serviceBoxTitle3: 'And send bulk transfers with three clicks and at no cost.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const REQUEST_TERMS_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    requestUserTermsPageTitle: 'Necesitamos tu confirmación',
    requestUserTermsMessage1: 'Estimado',
    requestUserTermsMessage2:
      ', para poder activar tu cuenta y explotes todo el potencial de EFEX necesitamos que aceptes nuestros términos y condiciones a continuación:',
    requestUserTermsAccept: 'Acepto los',
    requestUserTermsLink: 'términos y condiciones',
    requestUserLegalPageLink: 'página de legal',
    requestUserTermsMessage3:
      'Al registrarte en nuestra plataforma, confirmas que has leído y comprendido todos nuestros',
    requestUserTermsMessage4: 'en nuestra',
    requestUserTermsMessage5: 'que incluyen los Términos de servicio de EFEX.',
    serviceBoxTitle:
      'Puedes recibir transferencias en tu cuenta  empresarial en: ',
    serviceBoxSubtitle: 'USD, MXN, CNY, EUR, GBP, HKD, CAD y COP.',
    serviceBoxTitle2: 'Con EFEX puedes cerrar una tasa de cambio hoy',
    serviceBoxSubtitle2: 'y transferir hasta 365 días en el futuro.',
    serviceBoxTitle3:
      'Y enviar transferencias masivas con tres clicks y sin costo.',
  },
};

export default REQUEST_TERMS_LABELS;
